import { AdminActivityRecord, AdminAuditValue } from "../../../../services";
import { lisbonDateLabel, lisbonTime } from "../../utils/format";
import { FIELD_LABELS, TARGET_TYPE_LABELS } from "../constants";

const ISO_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

export const lisbonTimestamp = (at: string): string =>
  `${lisbonDateLabel(at)} at ${lisbonTime(at)} Lisbon`;

export const targetOf = ({
  targetType,
  targetId,
  targetLabel,
}: AdminActivityRecord): string =>
  targetLabel ?? `${TARGET_TYPE_LABELS[targetType]} #${targetId}`;

export const fieldLabelOf = (field: string): string => {
  const known = FIELD_LABELS[field];
  if (known) {
    return known;
  }
  const words = field.replace(/([a-z0-9])([A-Z])/g, "$1 $2").toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const formatAuditValue = (value: AdminAuditValue): string => {
  if (value === null) {
    return "—";
  }
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (typeof value === "string" && ISO_INSTANT.test(value)) {
    return lisbonTimestamp(value);
  }
  return String(value);
};
